<div class="container">
    <h2
        mat-dialog-title
        class="cut-long-text"
    >
        @if (!data.hasId()) {
        {{ "new_record" | transloco }}
        } @else {
        {{ "edit_record" | transloco }}
        }
    </h2>
    <mat-divider></mat-divider>
    <form
        [formGroup]="formGroup"
        class="pixl-form"
    >
        <mat-dialog-content>
            <br />
            <div>
                <mat-form-field>
                    <mat-label>{{ "title" | transloco }}</mat-label>
                    <input
                        matInput
                        formControlName="title"
                    />
                    @if (formGroup.get("title")?.hasError("required")) {
                    <mat-error>{{ "title_required" | transloco }}</mat-error>
                    }
                </mat-form-field>
            </div>
            <div>
                <mat-form-field>
                    <mat-label>{{ "subtitle" | transloco }}</mat-label>
                    <input
                        matInput
                        formControlName="subtitle"
                    />
                </mat-form-field>
            </div>
            <div class="content-container">
                <div>{{ "preview_label" | transloco }}</div>
                <div>
                    <button
                        class="extend-button"
                        mat-stroked-button
                        (click)="openImageChoice()"
                    >
                        <mat-icon>add_photo_alternate</mat-icon>
                        {{ "image_from_media" | transloco }}
                    </button>
                    @if (getImageName() && getImageName().length > 0) {
                    <span class="info cut-long-text">{{
                        getImageName()
                        }}</span>
                    }
                    <br />
                </div>
                <div>
                    @if (getImageName() && getImageName().length > 0) {
                    <div class="media-container">
                        <div class="media-item">
                            <button
                                mat-icon-button
                                [matTooltip]="'delete_image_file' | transloco"
                                class="button-delete"
                                (click)="deleteMediaEntry()"
                            >
                                <mat-icon>delete</mat-icon>
                            </button>
                        </div>
                        <div class="media-item">
                            <img
                                src="{{ imageUrl() }}"
                                alt=""
                                class="preview"
                            />
                        </div>
                    </div>
                    }
                </div>
            </div>
            <div>
                <br />
                <mat-form-field>
                    <mat-label>{{ "teaching_phase" | transloco }}</mat-label>
                    <input
                        matInput
                        formControlName="lesson_section"
                    />
                </mat-form-field>
            </div>
            <div>
                <mat-form-field>
                    <mat-label>{{ "processing_time" | transloco }}</mat-label>
                    <input
                        matInput
                        type="number"
                        formControlName="processing_time"
                    />
                </mat-form-field>
            </div>
            <div class="filter-item">
                <pixl-state-cb
                    [required]="true"
                    [initValue]="status"
                    (onStateChange)="statusChanged($event)"
                />
            </div>
            <div>
                <pixl-federal-states-combobox
                    [initValue]="federal_states"
                    (initValueChange)="federalStatesChanged($event)"
                />
            </div>
            <div>
                <mat-form-field>
                    <mat-label>{{ "learning_unit_goal" | transloco }}</mat-label>
                    <mat-select formControlName="learning_unit_goal">
                        <mat-option value="voluntarily">{{ "voluntary" | transloco }}</mat-option>
                        <mat-option value="mandatory">{{ "mandatory" | transloco }}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div>
                <mat-form-field>
                    <mat-label>{{ "learning_unit_type" | transloco }}</mat-label>
                    <input
                        matInput
                        formControlName="learning_unit_type"
                    />
                </mat-form-field>
            </div>
            <div>
                <mat-form-field>
                    <mat-label>{{ "description" | transloco }}</mat-label>
                    <textarea
                        matInput
                        formControlName="description"
                    ></textarea>
                </mat-form-field>
            </div>

            <div class="border-area full-width">
                <div class="learning-unit-select mt-2">
                    <pixl-multi-combo-search
                        [label]="'learning_sections' | transloco"
                        [observable$]="learningSections$"
                        [namingColumn]="'name'"
                        [externalSearch]="true"
                        (onStateChange)="receiveData($event)"
                        (onSearchChange)="receiveSearchQuery($event)"
                        [(selectedValues)]="learningSections"
                    />
                </div>

                <div class="mb-1">{{ "arrange_drag_drop" | transloco }}</div>
                <div
                    cdkDropList
                    class="learning-section-list"
                    (cdkDropListDropped)="reorderLearningSections($event)"
                >
                    @for (
                    learningSection of formGroup.get("learningSections")?.value;
                    track learningSection.id
                    ) {
                    <div
                        class="learning-section-box"
                        cdkDrag
                    >
                        {{ learningSection.title }}
                    </div>
                    }
                </div>
            </div>
        </mat-dialog-content>
    </form>
    <mat-divider></mat-divider>
    <div mat-dialog-actions>
        <button
            mat-raised-button
            (click)="onCancel()"
        >{{ "cancel" | transloco }}</button>
        <button
            mat-raised-button
            color="primary"
            (click)="onSave()"
        >
            {{ "save" | transloco }}
        </button>
    </div>
</div>